// THIS WIDGET IS NOT CURRENTLY GENERAL PURPOSE.  ITS TEMPLATE IS DESIGNED SUCH THAT IT WILL ONLY WORK WITH
// SYNDICATION FILTERING.
// TODO: MAKE THIS MORE GENERIC...as a matter of fact, make the whole thing simpler....
import filterSelectTemplate from '../templates/filterSelect.hbs';
import $ from 'jquery';
$.valHooks.sdaFilterSelect = {
    get(el) {
        return $(el).data();
    },
    set(el, val) {
        $(el)
            .trigger('change.val', val) // emits the event for outside listeners
            .trigger('set.val', val) // sets the local value
            .removeData()
            .data(val);

        return $(el).data();
    },
};
$.fn.sdaFilterSelect = function(data) {
    const that = this;
    let $searchResults = null,
        $searchInput = null,
        $selectedGroup = null;
    const filter = function() {};

    that[0].type = 'sdaFilterSelect';

    data = data || {};

    $.extend(data, that.data());

    that.addClass('sda-filter-select');
    that.html(filterSelectTemplate(data));

    $searchResults = that.find('.search-results');
    $searchResults.sdaSelectList();

    $searchInput = that.find('.search-input');
    $selectedGroup = that.find('.selected-group');

    // listeners
    that.on('keyup', filter).on('set.val', function(e, val) {
        if (!val.uuid || !val.text || $selectedGroup.is(':visible')) {
            e.stopPropagation();

            return false;
        }

        $selectedGroup
            .show()
            .find('.selected-item')
            .val(val.text);

        $searchResults.close();
    });

    // search result is clicked
    $searchResults.on('change.val', function(e, uuid) {
        const val = {uuid, text: $searchResults.find('.selected[data-selectable]').data('name')};

        e.stopPropagation();
        that.trigger('set.val', val).val(val);
        $searchInput.focus().val('');
    });

    $searchInput
        .on('focus', function() {
            if (!$selectedGroup.is(':visible')) {
                $searchResults.open();
            }
        })
        .on('focusout', function() {
            if (!that.is(':hover')) {
                $searchResults.close();
                $searchInput.val('');
            }
        })
        .on('change', function(e) {
            e.stopPropagation();
        });

    that.find('.remove-selected-package').on('click', function() {
        $selectedGroup.hide();
        $searchResults[0].clearList();
        $searchInput.focus().val('');
        that.val({});
    });

    if (data.uuid && data.text) {
        that.val({uuid: data.uuid, text: data.text});
    }

    return that;
};
